export default __webpack_public_path__ + "static/media/share-apple-positive.0cb56bde.svg";